<template>
  <div>
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <slot ></slot>
    </el-tabs>
  </div>
</template>
<script>

  export default {
    components: {
    },
    props: {
      tabs: {
        type: Array,
        default: function () {
          return []
        }
      },
      activeName: {
        type: String,
        default: '0'
      }
    },
    data() {
      return {
        tabName:"0",
      }
    },
    methods: {
      handleClick(tab, event) {
        this.$emit('tabChange', tab)
      }
    }
  };
</script>



// WEBPACK FOOTER //
// tabs.vue?dc60e43c